module.exports = __webpack_public_path__ + "static/media/reel-thadingyut-2025-theme.d0c3b08d.png";